import NotFound from 'common/NotFound';
import React, { useState } from 'react'
import { FaEdit } from 'react-icons/fa';
import { TbTruckDelivery } from 'react-icons/tb';
import UpdateFreeDelivery from './UpdateFreeDelivery';

const FreeDelivery = ({
  manageDeliveryList = [],
  setManageDeliveryList = () => { },
  onHide,
  slotType,
  getsManageDeliverySlots = () => { },
  handleSlotTabChange = () => { }
}) => {
  // console.log('manageDeliveryList in free', manageDeliveryList)
  const [updateSlot, setUpdateSlot] = useState({ modal: false })
   // -----update-slot-modal------------
  const handleSlotModal = (data, type) => {
    setUpdateSlot({ ...data, type, modal: true })
  }
  return (
    <div className="table-container">
      <table className="table custom_table">
        <thead>
          <tr>
            {/* <th className="nowrap text-center">S.No</th> */}
            <th className="nowrap text-center">Title</th>
            <th className="nowrap text-center">status</th>
            <th className="nowrap text-center">Value</th>
            <th className="nowrap text-center">From</th>
            <th className="nowrap text-center">to</th>
            <th className="nowrap text-center">Action</th>
          </tr>
        </thead>
        <div>
        </div>
        <tbody>
          {manageDeliveryList && manageDeliveryList.length > 0 ? (
            manageDeliveryList?.map((data, index) => {
              return (
                <tr key={index}>
                  {/* <td className="nowrap text-center">
                    {index + 1}
                  </td> */}
                  <td className="nowrap text-center">{data?.title}</td>
                  <td className="nowrap text-center">{data?.status}</td>
                  <td className="nowrap text-center">{data?.value || "N/A"}</td>
                  <td className="nowrap text-center">{data?.from || "N/A"}</td>
                  <td className="nowrap text-center">{data?.to || "N/A"}</td>
                  <td className="nowrap text-center">
                    <div className="button-container" >
                      <button
                        type="button"
                      onClick={() => handleSlotModal(data, 'Update')}
                      >
                        <FaEdit />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <NotFound
              cols={3}
              msg={"Free Delivery Slot Not Found"}
              onHide={onHide}
              icon={<TbTruckDelivery />}
            />
          )}
        </tbody>
      </table>

      <UpdateFreeDelivery
        show={updateSlot?.modal}
        close={() => setUpdateSlot({ modal: false })}
        data={updateSlot}
        slotType={slotType}
        listing={getsManageDeliverySlots}
      />
    </div>
  )
}

export default FreeDelivery